import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

import { IS_WEBAPP } from "@bryq/employers-src/settings";

export default class extends Controller {
  static targets = [
    "fieldset",
    "departmentSelect",
    "isActiveSelect",
    "submitButton",
  ];

  static classes = ["hidden"];

  connect() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.classList.add(this.hiddenClass);
    }

    if (this.hasDepartmentSelectTarget) {
      // Marks the first option as the placeholder.
      this.departmentSelectTarget.querySelector(
        "option:first-child",
      ).dataset.placeholder = "true";

      // Disables the select if its parent fieldset is disabled, so the
      // disabled state gets reflected in SlimSelect.
      if (this.hasFieldsetTarget) {
        this.departmentSelectTarget.disabled = this.fieldsetTarget.disabled;
      }

      // Prevents the select from being translated by Google Translate.
      // On this page, when the select gets translated, the SlimSelect library
      // will change the DOM for it which will trigger a new translation by
      // Google Translate, which will change the DOM again, and so on.
      // Checking the value of the select in the submit method is not enough to
      // get the translation to work...
      this.departmentSelectTarget.classList.add("notranslate");

      this.departmentSelect = new SlimSelect({
        select: this.departmentSelectTarget,
        settings: {
          allowDeselect: true,
          showSearch: true,
        },
      });
    }

    if (this.hasIsActiveSelectTarget) {
      // Marks the first option as the placeholder.
      this.isActiveSelectTarget.querySelector(
        "option:first-child",
      ).dataset.placeholder = "true";

      // Disables the select if its parent fieldset is disabled, so the
      // disabled state gets reflected in SlimSelect.
      if (this.hasFieldsetTarget) {
        this.isActiveSelectTarget.disabled = this.fieldsetTarget.disabled;
      }

      // Prevents the select from being translated by Google Translate.
      // On this page, when the select gets translated, the SlimSelect library
      // will change the DOM for it which will trigger a new translation by
      // Google Translate, which will change the DOM again, and so on.
      // Checking the value of the select in the submit method is not enough to
      // get the translation to work...
      this.isActiveSelectTarget.classList.add("notranslate");

      this.isActiveSelect = new SlimSelect({
        select: this.isActiveSelectTarget,
        settings: {
          allowDeselect: true,
          showSearch: false,
        },
      });
    }
  }

  submit(event) {
    /**
     * Hack to make the filters propagate to the webapp URL. To be removed when
     * the webapp is retired.
     */
    if (IS_WEBAPP) {
      event?.preventDefault();

      const { __reactRouter: reactRouter } = window;

      const { href } = window.location;
      const url = new URL(href);
      url.search = new URLSearchParams(new FormData(this.element)).toString();
      const to = url.href.replace(url.origin, "");

      // Prevents the router from navigating to the same page multiple times in
      // case the user clicks the submit button multiple times.
      const currentTo = `${reactRouter.state.location.pathname}${reactRouter.state.location.search}`;
      if (currentTo !== to) {
        reactRouter.navigate(to);
      }

      return;
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.click();
    }
  }

  triggerSearch(event) {
    const {
      currentTarget: { value },
    } = event;
    if (value === "") {
      this.submit();
    }
  }

  disconnect() {
    if (this.departmentSelect) {
      this.departmentSelect.destroy();
    }

    if (this.isActiveSelect) {
      this.isActiveSelect.destroy();
    }
  }
}
